import { zodResolver } from '@hookform/resolvers/zod';
import { useForm, type Resolver } from "react-hook-form";
import { Send } from 'lucide-react';

import Text from "@/components/forms/text";
import SmallSpinner from "@/components/shared/spinners/small-spinner";
import { Button } from '@/components/ui/button';
import { usePostParrainage } from '@/hooks/api/use-parrainages';
import { isParrainageEmail, isParrainagePhone, normalizeParrainagePhone, sendParrainageSchema, type SendParrainageValues } from '@/schemas/send-parrainage';

const initialValues: SendParrainageValues = {
    email: '',
    phone: '',
    index: undefined,
};

const SendParrainage = () => {
    const postParrainage = usePostParrainage();

    const { register, handleSubmit, watch, setValue, formState: { errors, touchedFields } } = useForm<SendParrainageValues>({
        defaultValues: initialValues,
        resolver: zodResolver(sendParrainageSchema) as unknown as Resolver<SendParrainageValues>,
    });

    const values = watch();

    return (
        <div className="mt-2 mb-2">
            <form onSubmit={handleSubmit(values => postParrainage.mutate(values))}>
                <div>
                    <Text
                        type={'text'}
                        label={'e-mail ou téléphone du filleul'}
                        {...register('text')}
                        functionOnChange={(value) => {
                            if (isParrainageEmail(value)) {
                                setValue('email', value, { shouldValidate: true });
                                setValue('phone', '', { shouldValidate: true });
                            } else if (isParrainagePhone(value)) {
                                setValue('phone', normalizeParrainagePhone(value), { shouldValidate: true });
                                setValue('email', '', { shouldValidate: true });
                            }

                        }}
                        value={values.text}
                        error={errors.text && touchedFields.text ? errors.text?.message : ''}
                    />
                </div>
                <div className="mt-6">
                    {
                        postParrainage.isPending
                            ? <SmallSpinner />
                            : <Button type="submit" className="w-full cursor-pointer">
                                <Send className="w-4 h-4" />
                                Envoyer
                            </Button>
                    }
                </div>
            </form>
        </div>
    );
};

export default SendParrainage;
